import React from 'react';

import { getPrice, mapEdgesToNodes } from '../../../utils/utils';
import { Question } from '../Icons';

const Totals = ({ cart, site }) => {
  const isUs = cart?.buyerIdentity?.countryCode === 'US';

  const duty = parseFloat(cart?.cost.totalDutyAmount?.amount) || 0;
  const tax = parseFloat(cart?.cost.totalTaxAmount?.amount) || 0;

  // prettier-ignore
  const linesAmount = cart?.lines.edges.reduce((acc, { node }) => {
    const compareAt = parseFloat(node.cost.compareAtAmountPerQuantity?.amount) || 0;
    const price = parseFloat(node.cost.amountPerQuantity.amount);
    const c = compareAt !== 0 && compareAt > price ? compareAt : price;
    return acc + (c * node.quantity)
  }, 0) || 0;

  // prettier-ignore
  const tariffs = cart?.lines.edges.reduce((acc, { node }) => {
    const origin = node.merchandise?.product?.countryOfOrigin?.value;
    const cost = node.cost;
    const sub = cost.amountPerQuantity.amount * node.quantity;

    const tariffPercentage = 40;
    const tariffFraction = 1 + (tariffPercentage / 100);
    const tariffs = origin === 'China'
      ? sub - (parseFloat(sub) / tariffFraction)
      : 0;

    return acc + tariffs;
  }, 0) || 0;

  const subTotal = Math.round(linesAmount * 100) / 100;

  const taxSubtracted = parseFloat(cart?.cost.totalAmount.amount) - tax;
  const total = Math.round(taxSubtracted * 100) / 100;

  const isDiscounted = Math.abs(subTotal - total);

  return (
    <div className="cart__totals">
      {false && (
        <div className="totals__total surcharges">
          <span>
            Included surcharges
            <span className="surcharges-popover-trigger">{Question}</span>
            <span className="surcharges-popover">
              A 24% tariff surcharge applies to products made in China, with
              Mustad absorbing the balance of the 54% total tariff. We
              appreciate your understanding and partnership as we navigate these
              changing trade conditions together.
            </span>
          </span>
          <span>{getPrice(site, tariffs)}</span>
        </div>
      )}

      <div className="totals__total">
        <span>Subtotal</span>
        <span>{getPrice(site, subTotal)}</span>
      </div>

      <div className="totals__total">
        <span>Discounts</span>
        <span>
          {isDiscounted ? '-' : ''}
          {getPrice(site, isDiscounted)}
        </span>
      </div>

      <div className="totals__total">
        <span>
          <strong>Estimated Total</strong>
        </span>
        {isDiscounted ? (
          <span className="price">
            <span className="price price--old">{getPrice(site, subTotal)}</span>
            <span className="price price--new">{getPrice(site, total)}</span>
          </span>
        ) : (
          <span className="price">{getPrice(site, total)}</span>
        )}
      </div>
    </div>
  );
};

export default Totals;
